import { isExperimentEnabled } from '@atlaskit/platform-feature-experiments/is-experiment-enabled';

export default {
	get(): boolean {
		return isExperimentEnabled('icp_search_input_filter');
	},
};
